import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {User} from '../../../auth/symbols';
import {GeneticData} from '../../types/dashboard-genetics-general.types';
import {GeneticFileProcessingStatus} from '../../types/dashboard-genetics-processing.types';

@Injectable()
export class DashboardGeneticsRetrieveService {

  constructor(private http: HttpClient) {
  }

  /**
   * Get statuses of all genetic files related to the account.
   */
  public getGeneticStatuses(userId: User['uid'], isPublic = false): Observable<GeneticFileProcessingStatus[]> {
    let url = `/api/research/genetic-derivatives-public/`;
    if (!isPublic) {
      url = `/api/research/genetic-derivatives/${userId}/`;
    }
    return this.http.get<GeneticFileProcessingStatus[]>(url);
  }

  /**
   * Download processed genetic data from backend.
   */
  public loadGeneticData(userId: User['uid'], isPublic = false): Observable<GeneticData> {
    let url = `/api/research/genetic-result-public/latest/`;
    if (!isPublic) {
      url = `/api/research/genetic-result/latest/${userId}/`;
    }
    return this.http.get<GeneticData>(url);
  }
}
